// Centralized theme tokens for all chart variants so the look stays consistent
// with the rest of the admin portal (which uses the blue/indigo Onivas palette).
export const CHART_PALETTE = [
  "#2f6df6",
  "#4224ec",
  "#00b8a9",
  "#f6a609",
  "#e94e77",
  "#7c4dff",
  "#26a69a",
  "#ff7043",
];

export const CHART_THEME = {
  fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
  axisColor: "#6c6c6c",
  gridColor: "#e5ecf6",
  tooltipBg: "#ffffff",
  tooltipBorder: "#d6dbe5",
  titleColor: "#1f2a44",
  emptyColor: "#6c6c6c",
};

export const getChartColor = (index = 0) =>
  CHART_PALETTE[index % CHART_PALETTE.length];
